import { EntityType } from '@frontend/common';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { CommonMessage } from '@frontend/lang';
import { RoleClient } from '@frontend/role/api';
import { CustomRole, Role } from '@frontend/role/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PlatformDetailGrid } from '../../modal/platform-detail-grid/platform-detail-grid.component';
import { PlatformObjectBadgeMapper } from '../../modal/platform-object-badge/platform-object-badge-mapper.component';
import { useAppDispatch } from '../../redux/store';
import { RoleRights } from './role-rights/role-rights.component';

export const ROLE_RIGHTS_LABEL = (
    <FormattedMessage
        id='platform.role.role-detail-modal.rights'
        description='Tab label for the rights section in the role detail modal'
        defaultMessage='Rights'
    />
);

export const RoleDetailsCard = ({ role }: { role: CustomRole }) => (
    <div className='bg-background-surface outline-border-default inline-flex w-full flex-col items-start justify-start gap-6 self-stretch rounded-xl p-4 outline-1 outline-offset-[-1px]'>
        <div className='text-foreground-default justify-start text-xl font-semibold'>{CommonMessage.DETAIL.DETAILS}</div>
        <PlatformDetailGrid
            object={role}
            cols={2}
            order={['name', 'entity_type', 'creation_timestamp']}
        />
    </div>
);

export const RoleRightsSection = ({ role }: { role: CustomRole }) => <RoleRights permissions={role.permissions} />;

export const RoleLinkedSection = ({ role }: { role: CustomRole }) => {
    const dispatch = useAppDispatch();
    return (
        <ReactiveObjectList<Role>
            id='role-detail-linked-roles'
            useStaticListId
            type={EntityType.ROLE}
            label={CommonMessage.OBJECTS.ROLE.PLURAL}
            eventListener={EntityType.ROLE}
            fetch={(arg) => RoleClient.fetchRoles({ ...arg, name: role.name, role_id: role.id })}
            dispatch={dispatch}
            columns={{
                columns: ['entity_id', 'uid', 'context'],
                entityColumnOverwrite: new Map([
                    ['entity_id', 'entity_type'],
                    ['uid', 'item']
                ]),
                customCells: new Map([
                    [
                        'context',
                        (row) => (
                            <td>
                                {row.row.original.context?.entity_type && row.row.original.context?.entity_id && (
                                    <PlatformObjectBadgeMapper
                                        id={row.row.original.context.entity_id}
                                        type={`${row.row.original.context.entity_type}_id`}
                                    />
                                )}
                            </td>
                        )
                    ]
                ])
            }}
            tableProps={{ defaultHeight: true, hideFooter: true }}
        />
    );
};
